export enum PortalPermissions {
    readScenario = 'READ_SCENARIO',
    upsertScenario = 'UPSERT_SCENARIO',
    deleteScenario = 'DELETE_SCENARIO',
    upsertRegimeType = 'UPSERT_REGIME_TYPE',
    deleteRegimeType = 'DELETE_REGIME_TYPE',
    upsertRegimePeriod = 'UPSERT_REGIME_PERIOD',
    deleteRegimePeriod = 'DELETE_REGIME_PERIOD',
}
